import createCrudService from '@core/api/create-crud-service';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

import type { TBaseQuery } from '@shared/types/base-query';
import type { TPlacementHostCompany } from '@shared/types/placement-host-company';

const placementHostCompanyApi = createCrudService<
  TPlacementHostCompany,
  TBaseQuery,
  Partial<TPlacementHostCompany>
>({
  queryKey: [QUERY_KEYS.getPlacementHostCompanies],
  url: 'placement-host-companies',
});

const importHosts = createCrudService<{ detail: string }, {}, { file: File }>({
  queryKey: [QUERY_KEYS.getPlacementHostCompanies, 'import'],
  url: 'placement-host-companies/import-host-companies',
});

export default placementHostCompanyApi;
export { importHosts };
